<template>
 
    <v-container>
        <div v-if="isAdminUser">
            <v-card elevation="2" shaped outlined>
        <div>
            <v-alert dismissible :value="successVisible" type="success" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
            <v-alert dismissible :value="errorVisible" type="error" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
        </div>
        <v-card-title>Source Contact List</v-card-title>
        

        <v-tabs
            v-model="tab"
            align-with-title
        >
            <v-tab key="tabUsers">Contact List</v-tab>
            <v-tab key="tabManagementContact">Management Contact Update </v-tab>
            <v-tab key="tabEmailPrimaryContact">Email Primary  Contact Update</v-tab>
        </v-tabs>   
        <v-tabs-items v-model="tab">
          <v-tab-item key="tabUsers">
              <v-card elevation="1" class="text-left">
                  <v-card-title>
                      
                  </v-card-title>
                  <v-card-subtitle>
                      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                  </v-card-subtitle>
                  <v-card-text>
                      <div>
                            <v-data-table
                            :headers="headers"
                            :items="userGrid"
                            :search="search"
                            :items-per-page="10"
                            class="elevation-1"
                            >
                            </v-data-table>
                        </div>
                  </v-card-text>
              </v-card>
          </v-tab-item>
          <v-tab-item key="tabManagementContact">
            
           
                <!--
                    <AddUserBuilding @addUserBuilding:click="onAddedUserBilding"></AddUserBuilding>
                -->
                

                <!--here the replacement-->
                <UserBuildingReplacement @UserBuildingReplacement:click="onUserBuildingReplacemen"></UserBuildingReplacement>
                <UserReplacement @replacement:click="replacementAction"></UserReplacement>
                
            
            
            
          </v-tab-item>
          <v-tab-item key="tabEmailPrimaryContact">
            <EmailPrimaryReplacementByBuilding @PrimaryReplacementBuilding:click="PrimaryReplacementBuilding"></EmailPrimaryReplacementByBuilding>
            <br/>
            <EmailPrimaryReplacement @PrimaryReplacement:click="onEmailPrimaryReplacement"></EmailPrimaryReplacement>
            
            
          </v-tab-item>
        </v-tabs-items>

    </v-card>
        </div>
        <div else>
            <h3>Access Denied</h3>
        </div>
    </v-container>
    
</template>
<script>
import userAPI from '@/services/userservice';
import UserReplacement from '@/components/users/UserReplacement';
export default {
    name:'GlobalUpdate',
    data:function(){
        return {
            tab:null,
            successVisible:false,
            errorVisible:false,
            alertMessage:'',
            
            headers:[
                { value:'userId', text:'User ID', align:'start', sortable:true},
                { value:'name', text:'User Name',align:'start', sortable:true},
                {value:'email', text:'Email',align:'start', sortable:true},
                { value:'buildings', text:'Assigned Buildings',align:'start', sortable:true}
                ],
            userGrid:[],
            search:'',
            criterios:[
                {value: 'user',text:'User'},
                {value:'buildingCode', text: 'Building'}
            ]
        }
    },
    methods:{
        
        hideAlert: function(){
             window.setInterval(()=>{
                this.successVisible=false;
                this.errorVisible=false;
            },10000);
        },
        
        async loadUserGrid(){
            await userAPI.getUsers()
            .then(response=>{
                this.userGrid=response.data;
            })
            .catch(error=>{console.log(error)});
        },
        async replacementAction(isValid, message)
        {
            this.alertMessage=message;
            if(isValid){
                this.successVisible=true;
            }else{
                this.errorVisible=true;
            }
            this.hideAlert();
        },
        async onAddedUserBilding(isSuccessfull,message){
            
            this.alertMessage=message;
            if(isSuccessfull)
                this.successVisible=true;
            else
                this.errorVisible=true;
            this.hideAlert();
        },
        async onUserBuildingReplacemen(isSucessfull,message){
            this.alertMessage=message;
            if(isSucessfull){
                this.successVisible=true;
                this.loadUserGrid();
            }
            else{
                this.errorVisible=true;
            }
            this.hideAlert();
        },
        async onEmailPrimaryReplacement(isSuccessfull,message)
        {
            console.log('here: ',isSuccessfull,message);
            this.alertMessage=message;
            if(isSuccessfull){
                this.successVisible=true;
                this.loadUserGrid();
            }
            else{
                this.errorVisible=true;
            }
            this.hideAlert();
        },
        async PrimaryReplacementBuilding(isSuccessfull,message)
        {
            this.alertMessage=message;
            if(isSuccessfull){
                this.successVisible=true;
                this.loadUserGrid();
            }else{
                this.errorVisible=true;
            }
            this.hideAlert();
        }
    },
    mounted: async function(){
        
        await this.loadUserGrid();
    },
    computed:{
        isAdminUser()
        {
            let foundIndex=this.$msal.data.user.idToken.roles.indexOf('radiation-admin-role');   
            
            console.log('foundIndex: ',foundIndex)
            if(foundIndex!=-1)
            {
                return true;
            }
            else
            {
                return false;
                
            }
        }
    },
    components:{
        UserReplacement,
        //AddUserBuilding:()=>import('../users/AddUserBuilding'),
        UserBuildingReplacement:()=>import('../users/UserBuildingReplacement'),
        EmailPrimaryReplacement:()=>import('../users/EmailPrimaryReplacement'),
        EmailPrimaryReplacementByBuilding:()=>import('../users/EmailPrimaryReplacementByBuilding')
    }
}
</script>
